import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import React from "react";
import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Service2() {
  const { t } = useTranslation();
  const imageRef = useRef(null);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animation de l'image (arrive de la gauche)
      gsap.fromTo(
        imageRef.current,
        {
          x: -100,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
          duration: 1.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: imageRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation du texte (arrive de la droite)
      gsap.fromTo(
        textRef.current,
        {
          x: 100,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
          duration: 1.2,
          ease: "power2.out",
          delay: 0.3, // Petit délai pour l'asynchrone
          scrollTrigger: {
            trigger: textRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="Accueil-Service Service2">
      <div className="TopSection">
        <p>[{t("services.label")}]</p>
        <h2>{t("service2.title")}</h2>
        <div className="Spacer"></div>
      </div>
      <article className="BottomSection">
        <img
          ref={imageRef}
          src={require("../../assets/img/Accueil/Service2.png")}
          alt=""
        />
        <div ref={textRef} className="BottomSection-Text">
          <article>
            <p>{t("service2.text1")}</p>
            <p>{t("service2.text2")}</p>
          </article>
          <ul>
            <span>
              {t("service2.tag1")
                .split("\n")
                .map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </span>

            <span>
              {t("service2.tag2")
                .split("\n")
                .map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </span>
          </ul>

          <Link to="/services" rel="noreferrer" className="websiteBtn thin">
            {t("services.more")}
          </Link>
        </div>
      </article>
    </div>
  );
}
